import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';

import axios from 'axios';
import { validaSoloNumero, validaNumeroTelefono, validaEmail } from '../../util/varios';
import moment from 'moment';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import CatalogoPersona from '../../catalogos/catalogoPersona';
import { TableContainer } from '@mui/material'
    ;
import { ActualizarCoordinacion } from './modalActualizarCoordinacion';

export const ActualizarDireccion = (props) => {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));

    const [activate, setActivate] = useState(false);
    const [msg, setMsg] = useState();
    const [mostrar3, setMostrar3] = useState(false);
    const [mostrar, setMostrar] = useState(false);
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [operacioncor, setOperacioncor] = useState(0);
    const [tecla, setTecla] = useState();
    const [activo, setActivo] = useState(true);
    const [activo1, setActivo1] = useState(false);
    const [fechaSistema, setFechaSistema] = useState(localStorage.getItem('fechasistema'));
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [select, setSelect] = useState('0');
    const [operacionPer, setOperacionPer] = useState(0);
    const [values, setValues] = useState({
        iddireccion: "",
        nombre: "",
        funciones: "",
        encargado: "",
        idefiscal: 0,
        sufijo: ""

    });
    const [persona, setPersona] = useState({
        cedula: "",
        correoe: "",
        tlf1: "",
        tlf2: "",
        apellidos: "",
        direccion: "",
        fnacimiento: "",
        nacionalidad: "",
        nombres: "",
        sexo: "",
    });
    const [coordinacion, setCoordinacion] = useState([]);
    const [activeTab, setActiveTab] = useState('tab-1');
    
    const [coord, setCoord] = useState()
    const [per, setPer] = useState()
    const [iddir, setIddir] = useState()
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtIdd = useRef();
    const txtCedula = useRef();
    const txtAbv = useRef();
    const txtNombred = useRef();
    const txtFunciones = useRef();
    const txtNombre = useRef();
    const txtApellido = useRef();
    const txtDireccion = useRef();
    const txtEmail = useRef();
    const txtTlf = useRef();
    const txtCel = useRef();
    const txtFechaNac = useRef();
    const cmbNacionalidad = useRef();
    const cmbSexo = useRef();


    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;
        if (txtAbv.current.value.trim() === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Campo Abv no debe ir Vacio', icono: 'informacion' });
            sigue = false;
            txtAbv.current.focus();
        } else if (txtNombred.current.value.trim() === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Nombre no deben ir Vacio', icono: 'informacion' });
            sigue = false;
            txtNombred.current.focus();
        } else if (txtFunciones.current.value.trim() === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Describa las Funciones', icono: 'informacion' });
            sigue = false;
            txtFunciones.current.focus();
        } else if (txtCedula.current.value.trim() === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Seleccionar la Persona Responsable', icono: 'informacion' });
            sigue = false;
            txtCedula.current.focus();
        } else if (txtNombre.current.value.trim() === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Error, Esta Persona no Existe!', icono: 'informacion' });
            sigue = false;
            txtNombre.current.focus();
        }

        else if (sigue) {

            let msg = '';
            if (operacion === 1) {
                msg = 'Esta Seguro de Registrar estos Datos?.';
            } else if (operacion === 2) {
                msg = 'Esta Seguro de Modificar estos Datos?.';
            } else if (operacion === 3) {
                msg = 'Esta Seguro de Eliminar estos Datos?.';
            }

            setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
        }

    };

    const Actualizar = () => {

        let endpoint = `${op.conexion}/api/configuracion/actualizardireccion/${operacion}`;
        let body;
        setActivate(true);

        body = {

            nid: parseInt(txtIdd.current.value),
            nom: txtNombred.current.value.trim(),
            fun: txtFunciones.current.value.trim(),
            enc: parseInt(txtCedula.current.value),
            efi: idefiscal,
            abv: txtAbv.current.value.trim(),
            operacionper: operacionPer,
            cor: txtEmail.current.value.trim(),
            ctlf1: txtTlf.current.value.trim(),
            ctlf2: txtCel.current.value.trim(),
            ape: txtApellido.current.value.trim(),
            dir: txtDireccion.current.value.trim(),
            fnac: txtFechaNac.current.value.trim(),
            nac: cmbNacionalidad.current.value.trim(),
            nombres: txtNombre.current.value.trim(),
            sex: cmbSexo.current.value.trim()
        };

        axios.post(endpoint, body, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status == 200) {

                if (props.operacion === 1) {
                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro creado correctamente', icono: 'exito' });
                } else if (props.operacion === 2) {
                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro modificado correctamente', icono: 'exito' });
                } else if (props.operacion === 3) {
                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro eliminado correctamente', icono: 'exito' });
                }

            }
            setActivate(false);
        }).catch(function (error) {

            setActivate(false);
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

        })

    }


    const cancelar = () => {
        blanquear();
        props.onHideCancela();
    }

    const blanquear = () => {
        setValues({
            iddireccion: "",
            nombre: "",
            funciones: "",
            encargado: "",
            idefiscal: 0,
            sufijo: ""
        });
        setPersona({
            cedula: "",
            correoe: "",
            tlf1: "",
            tlf2: "",
            apellidos: "",
            direccion: "",
            fnacimiento: "",
            nacionalidad: "",
            nombres: "",
            sexo: "",
        });
        setActivate(false);
    };


    const handleInputChange = (event) => {
        if (event.which === 13) {
            var valido;
            if (event.target.id === 'inputNombres') {
                txtApellido.current.focus();
            } else if (event.target.id === 'inputApellidos') {
                txtDireccion.current.focus();
            } else if (event.target.id === 'inputDireccion') {
                txtEmail.current.focus();
            } else if (event.target.id === 'inputEmail') {
                valido = validaEmail(event.target.value);
                if (valido) {
                    txtTlf.current.focus();
                } else {
                    if (event.target.value !== '') {
                        setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'Formato de Email invalido.', icono: 'informacion' });
                        event.target.value = '';
                    } else {
                        txtTlf.current.focus();
                    }
                }

            } else if (event.target.id === 'inputTlf') {
                txtCel.current.focus();
            } else if (event.target.id === 'inputCel') {
                txtFechaNac.current.focus();
            } else if (event.target.id === 'inputFechaNac') {
                cmbNacionalidad.current.focus();
            }
        } else if (typeof (event.which) === 'undefined') {
            if (event.target.id === 'inputEmail') {
                valido = validaEmail(event.target.value);
                if (valido) {
                    txtTlf.current.focus();
                } else {
                    if (event.target.value !== '') {
                        setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'Formato de número telefonico invalido.', icono: 'informacion' });
                        event.target.value = '';
                    } else {
                        txtTlf.current.focus();
                    }
                }

            } else if (event.target.id === 'inputTlf') {
                txtCel.current.focus();
            } else if (event.target.id === 'inputCel') {
                txtFechaNac.current.focus();
            } else {
                return false;
            }

        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;
    };

    const handleCloseCatalogoPer = () => {
        setMostrar3(false);
    }

    const handleAceptaCatalogoPer = (cedPer, nomPer, apePer, correoPer, tlf1Per,
        tlf2Per, fnacPer, nacPer, sexoPer, direPer) => {
        setMostrar3(false);
        txtCedula.current.value = cedPer;
        txtNombre.current.value = nomPer;
        txtApellido.current.value = apePer;
        txtDireccion.current.value = direPer;
        txtEmail.current.value = correoPer;
        txtTlf.current.value = tlf1Per;
        txtCel.current.value = tlf2Per;
        txtFechaNac.current.value = moment.utc(fnacPer).format('YYYY-MM-DD');
        cmbNacionalidad.current.value = nacPer;
        cmbSexo.current.value = sexoPer;
        btnAcepta.current.focus();
    }

    const catalogoPer = (e) => {
        e.preventDefault();
        setMostrar3(true);
    };

    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
        Actualizar();
    };

    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        props.onHideRenderizar();
        props.onHideCancela();
        blanquear();
    }

    const datosPer = (cedula) => {

        let campos = '*';
        let nomtab = 'persona';
        let nomid = 'cedula';

        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${cedula}&nomtab=${nomtab}&nomid=${nomid}`;
        setActivate(true);

        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status == 200) {

                txtNombre.current.value = '';
                txtApellido.current.value = '';
                txtDireccion.current.value = '';
                txtTlf.current.value = '';
                txtCel.current.value = '';
                cmbSexo.current.value = '';
                txtEmail.current.value = '';
                txtFechaNac.current.value = '';
                if (response.data !== '') {

                    setOperacionPer(0);
                    txtNombre.current.value = response.data.nombres.trim();
                    txtApellido.current.value = response.data.apellidos !== null ? response.data.apellidos.trim() : "";
                    txtDireccion.current.value = response.data.direccion !== null ? response.data.direccion.trim() : "";
                    txtEmail.current.value = response.data.correoe !== null ? response.data.correoe.trim() : "";
                    txtCedula.current.value = response.data.cedula.trim();
                    txtTlf.current.value = response.data.tlf1 !== null ? response.data.tlf1.trim() : "";
                    txtCel.current.value = response.data.tlf2 !== null ? response.data.tlf2.trim() : "";
                    cmbNacionalidad.current.value = response.data.nacionalidad !== null ? response.data.nacionalidad.toString() : "";
                    cmbSexo.current.value = response.data.sexo !== null ? response.data.sexo.toString() : "";
                    txtFechaNac.current.value = response.data.fnacimiento !== null ? moment.utc(response.data.fnacimiento).format('YYYY-MM-DD') : "";
                    setActivo(true);

                    if (tecla === 13) {
                        btnAcepta.current.focus();
                    }

                } else {
                    setOperacionPer(1);
                    if (tecla === 13) {
                        setTimeout(() => {
                            cmbNacionalidad.current.focus();
                            setActivo(false);

                        }, 100);
                    }
                }
            }
            setActivate(false);

        }).catch((error) => {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        })
    };

    const validarPersona = (event) => {
        event.preventDefault();
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.target.value !== '') {
                setTecla(event.which);
                datosPer(event.target.value);

            } else {
                txtNombre.current.value = '';
            }
        }
    };

    const SeleccionarCoordinacion = (id) => {

        let campos = "*"
        let nomtab = "coordinacion";
        let nomid = "idcoordinacion";
        setActivate(true);

        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`

        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status == 200) {

                if (response.data.idcoordinacion > 0) {
                    setCoord(response.data);
                    SeleccionarPersona(response.data);
                } else {
                    setCoord();
                    SeleccionarPersona(response.data);
                }

            }

        }).catch((error) => {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        })
    }

    const SeleccionarPersona = (data) => {

        let campos = "*"
        let nomtab = "persona";
        let nomid = "cedula";

        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${data.encargado}&nomtab=${nomtab}&nomid=${nomid}`

        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status == 200) {

                if (response.data.cedula > 0) {
                    setPer(response.data);
                    setMostrar(true);
                } else {
                    setPer()
                    setMostrar(true);
                }
                setActivate(false);
            }

        }).catch((error) => {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        })
    }

    const gestionarCoordinacion = (op, id) => (e) => {

        if (op === 4) {
            setOperacioncor(4);
            SeleccionarCoordinacion(id);
        } else if (op === 1) {
            setOperacioncor(op);
            setMostrar(true)
        } else if (op === 2) {
            setOperacioncor(op);
            SeleccionarCoordinacion(id);
        } else if (op === 3) {
            setOperacioncor(op);
            SeleccionarCoordinacion(id);
        }

    }

    const handleCancelar = () => {
        setMostrar(false);
        props.onHideRender(parseInt(txtIdd.current.value));
    }

    useEffect(() => {

        setCoordinacion(props.coordinacion);

    }, [props.coordinacion]);

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                setOperacion(props.operacion);
                setActiveTab('tab-1'); // Restablecer al primer tab al mostrar
                if (props.operacion !== 1) {
                    setPersona(props.persona);
                    setValues(props.direccion);
                    setIddir(props.direccion.iddireccion);
                    setSelect('1');
                } else {
                    setSelect('0');
                    cmbNacionalidad.current.value = "";
                    cmbSexo.current.value = "";
                    txtFechaNac.current.value = "";
                }
                btnAcepta.current.focus();
            }}
        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className='fw-bold text-light'><h3>{operacion === 1 ? 'Agregar Dirección.' : operacion === 2 ? 'Editar Dirección.' : operacion === 3 ? 'Eliminar Dirección.' : 'Consultar Dirección.'}</h3></div>
                <button className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <ActualizarCoordinacion
                    show={mostrar}
                    operacion={operacioncor}
                    coor={coord}
                    id={iddir}
                    persona={per}
                    onHideCancelar={handleCancelar}
                    onHideRenderizar={SeleccionarCoordinacion}
                />
                <CatalogoPersona mensaje={msg}
                    show={mostrar3}
                    onHideCancelaCatPer={handleCloseCatalogoPer}
                    onHideAceptaCatPer={handleAceptaCatalogoPer} />
                <Dimmer active={activate} inverted>
                </Dimmer>
                <div className='container-fluid bg-light rounded'>
                    <ul className="nav mb-3" id="ex-with-icons" role="tablist">
                        <li className="nav-item" role="presentation">
                            <button
                                className={`nav-link ${activeTab === 'tab-1' ? 'active' : ''} bg-blue-100 rounded text-light`}
                                onClick={() => setActiveTab('tab-1')}
                                type="button"
                                role="tab"
                                aria-selected={activeTab === 'tab-1'}
                            >
                                <i className="fas fa-user-edit fa-fw me-2"></i>Dirección
                            </button>
                        </li>
                        {operacion !== 1 ? (
                            <li className="nav-item" role="presentation">
                                <button
                                    className={`nav-link ${activeTab === 'tab-2' ? 'active' : ''} bg-blue-200 rounded text-light`}
                                    onClick={() => setActiveTab('tab-2')}
                                    type="button"
                                    role="tab"
                                    aria-selected={activeTab === 'tab-2'}
                                >
                                    <i className="fas fa-vote-yea fa-fw me-2"></i>Coordinación
                                </button>
                            </li>
                        ) : ''}
                    </ul>
                    <div className="tab-content" id="ex-with-icons-content">
                        <div className={`tab-pane fade ${activeTab === 'tab-1' ? 'show active' : ''}`} id="tab-1" role="tabpanel" aria-labelledby="ex-with-icons-tab-1">
                            <div className='col-md-12 row mx-auto px-0'>
                                <div className="input-group mb-2 input-group-sm col-sm-3">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">Código:</label>
                                    <input type="text" className="form-control text-uppercase" disabled={true} ref={txtIdd} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" defaultValue={values ? values.iddireccion.trim() : ''} id="inputCedula" />
                                </div>
                                <div className='col-md-6'></div>
                                <div className="input-group mb-2 input-group-sm col-sm-3">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">Abv:</label>
                                    <input type="text" className="form-control text-uppercase" autoComplete='off' disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} ref={txtAbv} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" defaultValue={values && values.sufijo !== null ? values.sufijo.trim() : ""} id="inputCedula" />
                                </div>
                            </div>

                            <div className='col-md-12 py-1'></div>

                            <fieldset className="row border-azul rounded mx-auto">
                                <legend className="float-none w-auto" >Datos Generales</legend>

                                <div className="input-group mb-2 input-group-sm col-sm-12">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">Nombre:</label>
                                    <input type="text" disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} autoComplete='off' ref={txtNombred} defaultValue={values ? values.nombre.trim() : ''} className="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputLogin" />
                                </div>
                                <div className="input-group mb-2 input-group-sm col-sm-12">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">Funciones:</label>
                                    <input type="text" disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} autoComplete='off' ref={txtFunciones} defaultValue={values ? values.funciones.trim() : ''} className="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputEmailUsuario" />
                                </div>

                            </fieldset>

                            <div className='col-md-12 py-2'></div>

                            <fieldset className="row border-azul rounded mx-auto">
                                <legend className="float-none w-auto" >Datos del Encargado 21</legend>


                                <div className="input-group  input-group-sm col-sm-5 mb-2">
                                    <label className="input-group-text" id="inputGroup-sizing-sm"><i className="far fa-lg px-1 fa-id-card"></i>Cedula:</label>
                                    <select className="form-select col-2 px-1" disabled={activo} ref={cmbNacionalidad} aria-label="Default select example " defaultValue={props.persona && props.persona.nacionalidad !== null ? props.persona.nacionalidad.trim() : ''} id="inputNac" >
                                        <option value="V">V</option>
                                        <option value="J">J</option>
                                        <option value="E">E</option>
                                    </select>
                                    <input type="text" disabled={operacion === 4 || operacion === 3 ? true : activo1} autoComplete='off' ref={txtCedula} onKeyUp={validarPersona} onBlur={validarPersona} className="form-control col-4 px-2" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputCedula" defaultValue={persona ? persona.cedula : ''} />
                                    <button disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} onClick={catalogoPer} className="btn btn-sm  btn-info" ><i className="fa fa-search"></i> </button>
                                </div>
                                <div className="input-group  input-group-sm col-sm-3 mx-auto mb-2">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">Sexo:</label>
                                    <select className="form-select" disabled={activo} ref={cmbSexo} aria-label="Default select example " defaultValue={props.persona ? props.persona.sexo.trim() : ''} id="inputSexo" >
                                        <option key="0" value="M">M</option>
                                        <option key="1" value="F">F</option>
                                    </select>
                                </div>
                                <div className="input-group  input-group-sm col-sm-4 mb-2 px-0">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">Fecha Nacimiento:</label>
                                    <input type="date" className="form-control text-uppercase" disabled={activo} ref={txtFechaNac} max={moment.utc(fechaSistema).format('YYYY-MM-DD')} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" defaultValue={props.persona ? moment.utc(props.persona.fnacimiento).format('YYYY-MM-DD') : ''} id="inputFnac" onKeyUp={handleInputChange} onBlur={handleInputChange} />
                                </div>



                                <div className="input-group mb-2 input-group-sm col-sm-6">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">Nombres:</label>
                                    <input type="text" className="form-control text-uppercase" disabled={activo} autoComplete='off' ref={txtNombre} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" defaultValue={persona ? persona.nombres : ''} id="inputNombres" onKeyUp={handleInputChange} onBlur={handleInputChange} />
                                </div>
                                <div className="input-group mb-2 input-group-sm col-sm-6">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">Apellidos:</label>
                                    <input type="text" className="form-control text-uppercase" disabled={activo} autoComplete='off' ref={txtApellido} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" defaultValue={persona ? persona.apellidos.trim() : ''} id="inputApellidos" onKeyUp={handleInputChange} onBlur={handleInputChange} />
                                </div>
                                <div className="input-group mb-2 input-group-sm col-sm-12">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">Direccion:</label>
                                    <input type="text" className="form-control text-uppercase" disabled={activo} autoComplete='off' ref={txtDireccion} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" defaultValue={persona ? persona.direccion.trim() : ''} id="inputDireccion" onKeyUp={handleInputChange} onBlur={handleInputChange} />
                                </div>

                                <div className="input-group mb-2 input-group-sm col-sm-6">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">E-mail:</label>
                                    <input type="text" className="form-control text-uppercase" disabled={activo} autoComplete='off' ref={txtEmail} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" defaultValue={persona ? persona.correoe : ''} id="inputEmail" onKeyUp={handleInputChange} onBlur={handleInputChange} />
                                </div>
                                <div className="input-group mb-2 input-group-sm col-sm-3">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">Telefono:</label>
                                    <input type="text" className="form-control text-uppercase" disabled={activo} ref={txtTlf} autoComplete='off' aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" defaultValue={persona ? persona.tlf1 : ''} id="inputTlf" onKeyUp={handleInputChange} onBlur={handleInputChange} />
                                </div>

                                <div className="input-group mb-2 input-group-sm col-sm-3">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">Celular:</label>
                                    <input type="text" className="form-control text-uppercase" disabled={activo} ref={txtCel} autoComplete='off' aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" defaultValue={persona ? persona.tlf2 : ''} id="inputCel" onKeyUp={handleInputChange} onBlur={handleInputChange} />
                                </div>


                            </fieldset>
                        </div>
                        <div className={`tab-pane fade ${activeTab === 'tab-2' ? 'show active' : ''}`} id="tab-2" role="tabpanel" aria-labelledby="ex-with-icons-tab-2">

                            <div className="row col-md-12 mx-auto px-1 mt-2">
                                <fieldset className=' row col-md-12 border-azul rounded mx-auto'>
                                    <legend className="float-none w-auto" > Coordinaciones Registradas</legend>

                                    <div className="row col-md-12 d-flex justify-content-end" style={{ padding: '10px' }}>
                                        <div className="col-md-4 col-xs-2 d-flex justify-content-end">
                                            <button className="btn btn-sm btn-primary rounded-circle" onClick={gestionarCoordinacion(1, '')} ><i className="fas fa-plus"></i></button>
                                        </div>
                                    </div>
                                    <TableContainer className='h-150p max-250p'>
                                        <table className="table table-striped text-light table-hover" style={{ border: "solid #055182" }}>
                                            <thead>
                                                <tr className='azulGradiant'>
                                                    <th className='text-center'>NOMBRE</th>
                                                    <th className='text-center'>ENCARGADO</th>
                                                    <th className='text-center'>OPCIONES</th>
                                                </tr>
                                            </thead>

                                            <tbody className='border-light'>
                                                {
                                                    coordinacion && coordinacion.map((item, index) => (

                                                        <tr key={index + item.idcoordinacion}>
                                                            <td className='text-dark' align="center" style={{ fontSize: '12px' }}>{item.nombre}</td>
                                                            <td className='text-dark' align="center" style={{ fontSize: '12px' }}>{item.responsable}</td>
                                                            <td className='text-dark ' align="center">

                                                                <button onClick={gestionarCoordinacion(4, item.idcoordinacion)} className="btn btn-sm  btn-info rounded-circle ml-2"><i className="fas fa-eye"></i> </button>
                                                                <button onClick={gestionarCoordinacion(2, item.idcoordinacion)} className="btn btn-sm  btn-warning rounded-circle ml-2"><i className="fa fa-edit"></i> </button>
                                                                <button onClick={gestionarCoordinacion(3, item.idcoordinacion)} className="btn btn-sm btn-danger rounded-circle ml-2"><i className="fa fa-trash-alt"></i></button>

                                                            </td>
                                                        </tr>
                                                    ))}

                                            </tbody>

                                        </table>
                                    </TableContainer>

                                </fieldset>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" ref={btnAcepta} onClick={onChangeValidar} disabled={operacion === 4 ? true : false} style={{ margin: '1px' }} className="col-sm-2 btn btn-success btn-sm rounded-pill"><i className="far fa-check-circle"></i>Aceptar</button>
                <button type="button" ref={btnCancela} onClick={cancelar} style={{ margin: '1px' }} className="col-sm-2 btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"></i>Cancelar</button>
            </Modal.Footer>
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === 'Exito.' ?
                        cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        </Modal>

    );
}